export class QList {
  constructor() {
    this.fListID = null;
    this.fLastSelectedID = null;
    this.fShowMore = false;
    this.fParentPanel = null;
    this.fEnableShuffleUp = false;
    this.fEnableShuffleDown = false;
  }

  ExecuteCommand(aCmd) {
    var panelHandled = true;
    var cmdCode = aCmd.GetCmdCode();
    var sourceElement = aCmd.GetSourceElement();
    var cmdProcessor = cmdCode.split("-");
    if (cmdProcessor.length > 1 && cmdProcessor !== cmdCode) {
      cmdCode = cmdProcessor.shift();
      var subCode = cmdProcessor.join("-");
    }
    var dataSource = this.fDataSource;
    var index = sourceElement.GetListElementID();

    if (index == null || index == undefined) {
      // scenario where a control button was clicked
      index =
        this.fLastSelectedID !== null && this.fLastSelectedID !== undefined
          ? this.fLastSelectedID
          : subCode; // if button clicked was a control button, check last selectedID or subCode
    }

    index = parseInt(index);
    switch (cmdCode) {
      case "Select":
        this.fLastSelectedID = index;
        break;
      case "Add":
        try {
          var value = JSON.parse(subCode);
        } catch (exception) {
          value = subCode;
        }
        dataSource.push(value);
        break;
      case "ShuffleUp":
        var prevItem = dataSource[index - 1];
        var curItem = dataSource[index];
        dataSource[index] = prevItem;
        dataSource[index - 1] = curItem;
        index--;
        this.fLastSelectedID = index;
        break;
      case "ShuffleDown":
        var nextItem = dataSource[index + 1];
        var curItem = dataSource[index];
        dataSource[index] = nextItem;
        dataSource[index + 1] = curItem;
        index++;
        this.fLastSelectedID = index;
        break;
      case "Remove":
        dataSource.splice(index, 1);
        this.fLastSelectedID = null;
        break;
      case "ToggleMore":
        this.fShowMore = !this.fShowMore;
        break;
      case "Reset":
        if (this.fResetList == null) break;
        this.fDataSource = this.fResetList.slice(0);
        break;
      default:
        panelHandled = false;
        break;
    }

    this.EnableShuffleControls();

    return panelHandled;
  }

  Pop(idx) {
    var dataSource = this.fDataSource;
    if (idx == null) return dataSource.pop();
    return dataSource.splice(idx, 1)[0];
  }

  // remove element at idx from this, add to aList
  PassElement(idx, aList) {
    var element = this.Pop(idx);
    var dataSource = aList.fDataSource;
    dataSource.push(element);
    this.fLastSelectedID = null;
  }

  CopyItemToListByIdx(idx, targetList, allowDups) {
    var element = this.fDataSource[idx];
    var dstSrc = targetList.fDataSource;
    if (dstSrc.indexOf(element) === -1 || allowDups) dstSrc.push(element);
    this.fLastSelectedID = null;
  }

  UpdateDataSource(newData) {
    this.fDataSource = newData;
  }

  GetLastSelectedID() {
    return this.fLastSelectedID;
  }

  GetListID() {
    return this.fListID;
  }

  GetDataSource() {
    return this.fDataSource;
  }

  GetFilteredList(filterKey) {
    var filteredList = this.fDataSource;
    if (filterKey) filteredList = this.fDataSource.filter(this.FilterValues(filterKey));
    return filteredList;
  }

  FilterValues(string) {
    return function (item) {
      if (item !== null) return item.toLowerCase().lastIndexOf(string.toLowerCase()) !== -1;
    };
  }

  EnableShuffleControls() {
    this.fEnableShuffleUp = false;
    this.fEnableShuffleDown = false;

    var count = this.fListMgr.GetListCount(this.fListID);
    var selectedID = parseInt(this.fLastSelectedID);
    if (this.fDataSource && selectedID !== null && selectedID > -1) {
      this.fEnableShuffleDown = selectedID + 1 < count;
      this.fEnableShuffleUp = selectedID !== 0;
    }
  }
}
